var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalId,
            size: _vm.modalSize,
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "no-fade": "",
            "no-stacking": "",
            "hide-footer": "",
            centered: ""
          },
          on: { show: _vm.getSubscriptionInformation, hide: () => {} },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("div", [
                    _c(
                      "h2",
                      {
                        staticClass: "modal-title",
                        attrs: {
                          "data-test-hook": "new-subscription-modal-header"
                        }
                      },
                      [
                        _c("div", [
                          _c("i", {
                            staticClass: "far fa-badge-dollar colorOrange mr-1",
                            attrs: {
                              "data-test-hook":
                                "new-subscription-modal-header-icon"
                            }
                          }),
                          _vm._v(" " + _vm._s(_vm.modalTitle) + " ")
                        ])
                      ]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.isLoadingSubscriptionData
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-spinner", {
                            staticStyle: { width: "10rem", height: "10rem" },
                            attrs: { variant: "warning", label: "Spinning" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.activeView === _vm.subscriptionViews.UPGRADE_SINGLE_MULTI
                    ? _c("AddApparatusUpgradeSubscription", {
                        attrs: {
                          isEnrollment: false,
                          currentSubscription: _vm.existingSubscription,
                          newSubscription: _vm.selectedProduct,
                          apparatusList: _vm.apparatusList,
                          "new-apparatuses": _vm.apparatusesToAddToPlan,
                          isCreatingPurchaseIntent: _vm.isCreatingPurchaseIntent
                        },
                        on: { openPayment: _vm.proceedToPayment }
                      })
                    : _vm._e(),
                  _vm.activeView === _vm.subscriptionViews.UPGRADE_BASIC_MULTI
                    ? _c("UpgradeBasicToMulti", {
                        attrs: {
                          "new-subscription": _vm.productList,
                          "current-subscription": [],
                          "new-apparatuses": _vm.apparatusList,
                          "apparatus-list": _vm.apparatusList
                        },
                        on: {
                          openPayment: _vm.proceedToPayment,
                          setSelectedProduct: _vm.setSelectedProduct
                        }
                      })
                    : _vm._e(),
                  _vm.activeView === _vm.subscriptionViews.EXISTING_SUB
                    ? _c("UpgradeApparatusesExistingSub", {
                        attrs: {
                          "current-subscription": _vm.existingSubscription,
                          "apparatus-list": _vm.apparatusList
                        },
                        on: {
                          updateExistingProductApparatuses:
                            _vm.updateExistingProductApparatuses
                        }
                      })
                    : _vm.activeView === _vm.subscriptionViews.UPGRADE_LEGACY
                    ? _c("UpgradeFromLegacy", {
                        attrs: {
                          accountData: _vm.accountProfile,
                          legacySubscriptions: _vm.activeLegacySubscriptions,
                          selectedProduct: _vm.selectedProduct,
                          annualProduct: _vm.productList,
                          apparatusList: _vm.apparatusList
                        },
                        on: {
                          setSelectedProduct: _vm.setSelectedProduct,
                          openPayment: _vm.proceedToPayment
                        }
                      })
                    : _vm.activeView === _vm.subscriptionViews.ERROR
                    ? _c("SubscriptionInfoError", {
                        on: { retry: _vm.getSubscriptionInformation }
                      })
                    : _vm._e()
                ],
                1
              )
        ]
      ),
      _c("PaymentModal", {
        attrs: {
          "modal-id": `${_vm.modalId}-payment`,
          "selected-product": _vm.selectedProduct,
          "account-profile": _vm.accountProfile
        },
        on: {
          submit: _vm.payForProduct,
          goBack: _vm.returnToSubscriptions,
          savePremiumFeaturesGettingReadyInfo:
            _vm.savePremiumFeaturesGettingReadyInfo
        }
      }),
      _c("TankUtilityEnrollmentModals"),
      _c("EnrollmentModals"),
      _c(
        "Modal",
        {
          attrs: {
            modalId: "update-apparatuses-spinner-modal",
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalBody",
            {
              staticStyle: { "padding-top": "100px", "padding-bottom": "100px" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center"
                },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "10rem", height: "10rem" },
                    attrs: { variant: "warning" }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }